import { getCurrentContentScheduledDatesSelector } from '@lumapps/contents/ducks/selectors';
import { useWatch } from '@lumapps/lumx-forms';
import { useSelector } from '@lumapps/redux/react';

import { CONTENT_PROPERTIES_NAMES } from '../constants';
import { legacyDateInputToIsoString } from '../utils/legacyDateInputToIsoString';

export const useCurrentDates = () => {
    let currentStartDate: string | undefined;
    let currentEndDate: string | undefined;
    const { currentEndDate: currentEndDateInput, currentStartDate: currentStartDateInput } = useSelector(
        getCurrentContentScheduledDatesSelector,
    );

    try {
        [currentStartDate, currentEndDate] = useWatch({
            name: [CONTENT_PROPERTIES_NAMES.SCHEDULE_DATE, CONTENT_PROPERTIES_NAMES.EXPIRATION_DATE],
        });
    } catch (error) {
        currentStartDate = legacyDateInputToIsoString(currentStartDateInput);
        currentEndDate = legacyDateInputToIsoString(currentEndDateInput);
    }

    return {
        currentStartDate,
        currentEndDate,
    };
};
